import * as React from 'react'

function SvgItLinkedin(props) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M16.53 8.68A3.94 3.94 0 0013 10.62V9H9.37v12h3.73v-5.95c0-1.57.29-3.09 2.24-3.09 1.95 0 1.93 1.8 1.93 3.19V21H21v-6.6c0-3.23-.69-5.72-4.47-5.72zM5.16 3a2.17 2.17 0 102.16 2.18A2.16 2.16 0 005.16 3zM3.29 9v12H7V9H3.29zm13.24-.3A3.94 3.94 0 0013 10.62V9H9.37v12h3.73v-5.95c0-1.57.29-3.09 2.24-3.09 1.95 0 1.93 1.8 1.93 3.19V21H21v-6.6c0-3.23-.69-5.72-4.47-5.72v.02zM3.29 21H7V9H3.29v12zM5.16 3a2.17 2.17 0 102.16 2.18A2.16 2.16 0 005.16 3z" />
    </svg>
  )
}

export default SvgItLinkedin
